import {useState, useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import "./assets/styles.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { authRoutes } from "./routes";
import AdminLayout from "./layouts/Admin";
import AuthLayout from "./layouts/Auth";
import './App.css';
import { checkAuth, logoutUser } from './redux/actions/authActions';
import { api } from './api/config';
import LoadingIndicator from './components/LoadingIndicator/LoadingIndicator';
import { filteredRoutes } from './Helpers/filteredRoutes';

const App = () => {
  const [activeCalls, setActiveCalls] = useState(0);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  useEffect(() => {
  const expiration = localStorage.getItem("TokenExpiration");
  if (expiration) {
    const now = new Date().getTime();
    if (now > parseInt(expiration, 10)) {
      dispatch(logoutUser());
    }
  }
  }, [dispatch]); 

  useEffect(() => {
    dispatch(checkAuth());
    
    api.interceptors.request.use(
      (config) => {
        setActiveCalls(prev => prev + 1);
        const token = localStorage.getItem("AuthToken");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        setActiveCalls(prev => prev - 1);
        return Promise.reject(error);
      }
    );

    api.interceptors.response.use(
      (response) => {
        setActiveCalls(prev => prev - 1);
        return response;
      },
      (error) => {
        setActiveCalls(prev => prev - 1);
        if (error.response?.status === 401) {
          dispatch(logoutUser());
        }
        return Promise.reject(error);
      }
    );
  }, [dispatch]);

  if (loading) {
    return <LoadingIndicator show={true} />;
  }
  
  const routes = filteredRoutes();
  

  return (
    <Router>
      <LoadingIndicator show={activeCalls > 0}/>
      <Routes>
        <Route path="*" element={<Navigate to="/index" replace />} />
        
        {routes.map((route, index) => (
          <Route
            key={route.path || index}
            path={route.path} 
            element={
              <AdminLayout>
                {route.component}
              </AdminLayout>
            } 
          />
        ))}
          <Route 
            path={authRoutes[0].path} 
            element={
              <AuthLayout>
                {authRoutes[0].component}
              </AuthLayout>
            } 
          />
          <Route 
            path={authRoutes[1].path} 
            element = {
              <AuthLayout>
                {authRoutes[1].component}
              </AuthLayout>
            }
          />
      </Routes>
    </Router>
  )

}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <App />
    </LocalizationProvider>
  </Provider>

);
